import React, {} from "react";

export const About = () => (
	<div className="jumbotron">
		<div className="container">
			<h1 className="display-4">The best React App</h1>
			<p className="lead">Latest Version <strong>2.3.4.45</strong></p>
			<p className="lead">LTS Version <strong>2.3.3.2</strong></p>
		</div>
	</div>
)

